import { render } from "./circle-24.vue?vue&type=template&id=60c297fa&scoped=true"
import script from "./circle-24.vue?vue&type=script&lang=js"
export * from "./circle-24.vue?vue&type=script&lang=js"

import "./circle-24.vue?vue&type=style&index=0&id=60c297fa&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c297fa"]])

export default __exports__